<template>
  <div id="schedulingLog">
    <!-- <iframe :src="url" width="100%" height="100%" scrolling="auto"></iframe> xxl-job-admin/joblog/index1-->
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <span class="title">执行器</span>
        <Select v-model="jobGroup" style="width: 208px; margin-right: 10px;" @on-change="handleTask">
          <Option v-for="item in selectList" :value="item.id" :key="item.id">{{ item.title }}</Option>
        </Select>
        <span class="title">任务</span>
        <Select v-model="jobId" style="width:200px" @on-change="handleJob">
          <Option v-for="item in jabData" :value="item.id" :key="item.id">{{ item.jobDesc }}</Option>
        </Select>
        <span class="title">状态</span>
        <Select v-model="logStatus" style="width:200px" @on-change="handleStatus">
          <Option v-for="item in allSelect" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <span class="title">调度时间</span>
        <Select v-model="dateType" style="width: 208px; margin-right: 10px;" @on-change="handleTimer">
          <Option v-for="item in toDay" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <DatePicker v-model="dateArray" type="daterange" placeholder="请选择日期" style="width: 230px; margin-right: 10px;"
          @on-change="handleDateChange"></DatePicker>
        <Button class="ys-confirm" @click="handleClear">清除</Button>
      </div>
      <div>
        <Button type="primary" @click="handleAddClick">清理</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      @on-btn-click="onBtnClick">
    </el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :current="page" :page-size="12" :total="totalCount" @on-change="handlePagingClick" />
    </div>
    <div>
      <Alter ref="alterModal" :configData="configData" @change_ok="confirmDel"></Alter>
    </div>
    <!-- 日志清理 -->
    <model-component v-if="modelStatus" :modelStatus="modelStatus" @handle-model="handleModel" />
    <!-- 查看详情 -->
    <detail-model v-if="nextStatus" :nextStatus="nextStatus" :cronList="cronList"
      @handle-next-model="handleModelDetail"></detail-model>
  </div>
</template>
<script>
  import {
    mapActions
  } from "vuex";
  import moment from 'moment';
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import Columns from './tableConfig.js'
  import ModelComponent from './Model';
  import DetailModel from './detailModel';
  export default {
    components: {
      'el-table': ElTable,
      'model-component': ModelComponent,
      'detail-model': DetailModel
    },
    data() {
      return {
        tableData: [{
          name: 'John Brown',
          age: 18,
          address: 'New York',
          id: 667,
          dto: {
            sex: 2,
            job: 'wewe'
          },
          inputValue: 23,
        }], // 数据
        Columns: [], // 表头
        totalCount: 100, // 总条数
        tableHeight: 0,
        searchValue: '', // 搜索框的值
        model1: '',
        modelStatus: false, // 控制清理弹框
        nextStatus: false,
        dateType: '04',
        allSelect: [{
            value: -1,
            label: '全部'
          },
          {
            value: 1,
            label: '成功'
          },
          {
            value: 2,
            label: '失败'
          },
          {
            value: 3,
            label: '进行中'
          }
        ],
        toDay: [{
            value: '01',
            label: '今日'
          },
          {
            value: '02',
            label: '昨日'
          },
          {
            value: '03',
            label: '本月'
          },
          {
            value: '04',
            label: '上个月'
          },
          {
            value: '05',
            label: '最近一周'
          },
          {
            value: '06',
            label: '最近一月'
          },
        ],
        start_bk_date: '', //开始日期
        end_bk_date: '', //结束日期
        jobGroup: '',
        selectList: null,
        jabData: null,
        jobId: '',
        logStatus: '',
        page: 1,
        dateArray: [],
        configData: {}, // 弹框配置信息
        id: '',
        cronList: null,
        tableLoading: true, // 表格loading
      }
    },
    methods: {
      ...mapActions([
        'sa_SpringJobInfoView_index', // 下拉列表
        'sa_SpringJonLogView_getJobsByGroup', // 根据执行器去查询任务
        'sa_SpringJonLogView_pageList', // 列表
        'sa_SpringJonLogView_logKill', // 关闭
        'sa_SpringJonLogView_logDetail', // 查看详情
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("schedulingLog"), (element) => {
          _this.tableHeight = (element.scrollHeight - 66 - 90);
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        this.id = rowItem.id;
        switch (options.name) {
          case '关闭':
            this.DeleteComponent();
            break;
          case '查看':
            this.sa_SpringJonLogView_logDetails();
            break;
          default:
            break;
        }
      },
      // 清除功能
      handleAddClick() {
        this.modelStatus = true;
      },
      // 分页功能
      handlePagingClick(res) {
        this.page = res;
        this.sa_SpringJonLogView_pageLists();
      },
      // 日志清理弹框回调
      handleModel(res) {
        this.modelStatus = false;
        this.page = 1;
        // 获取列表
        this.sa_SpringJonLogView_pageLists();
      },
      handleModelDetail() {
        this.nextStatus = false;
      },
      // 修改执行器
      handleTask() {
        this.sa_SpringJonLogView_getJobsByGroups();
        this.page = 1;
        // 获取列表
        this.sa_SpringJonLogView_pageLists();
      },
      // 任务
      handleJob() {
        this.page = 1;
        // 获取列表
        this.sa_SpringJonLogView_pageLists();
      },
      // 状态
      handleStatus() {
        this.page = 1;
        // 获取列表
        this.sa_SpringJonLogView_pageLists();
      },
      // 时间
      handleTimer() {
        this.page = 1;
        // 获取列表
        this.sa_SpringJonLogView_pageLists();
      },
      // 日期change
      handleDateChange() {
        this.dateType = '';
        this.page = 1;
        // 调用数据
        this.sa_SpringJonLogView_pageLists();
      },
      // 清除
      handleClear() {
        this.jobGroup = ""; // 任务描述
        this.jobId = "";
        this.logStatus = ""; // 负责人
        this.dateType = "";
        this.dateArray = [];
      },
      // 关闭
      DeleteComponent() {
        this.configData = {
          type: "warning",
          title: "警告",
          content: "是否关闭当前信息"
        };
        this.$refs.alterModal.OpenModal();
      },
      confirmDel() {
        this.sa_SpringJonLogView_logKills();
      },
      // 获取下拉列表
      async sa_SpringJobInfoView_indexs() {
        try {
          const data = await this.sa_SpringJobInfoView_index();
          this.selectList = data.JobGroupList;
        } catch (error) {
          console.log(error);
        }
      },
      // 查询任务
      async sa_SpringJonLogView_getJobsByGroups() {
        try {
          const data = await this.sa_SpringJonLogView_getJobsByGroup({
            jobGroup: this.jobGroup
          });
          this.jabData = data;
        } catch (error) {
          console.log(error);
        }
      },
      // 列表
      async sa_SpringJonLogView_pageLists() {
        try {
          this.tableLoading = true;
          const parmas = {
            jobGroup: this.jobGroup,
            jobId: this.jobId,
            logStatus: this.logStatus,
            start: (this.page - 1) * 12,
            length: 12,
            startDate: this.dateArray.length !== 0 && this.dateArray[0] !== '' ? moment(this.dateArray[0]).format(
              'YYYY-MM-DD') : '',
            endDate: this.dateArray.length !== 0 && this.dateArray[0] !== '' ? moment(this.dateArray[1]).format(
              'YYYY-MM-DD') : '',
            dateType: this.dateArray.length !== 0 && this.dateArray[0] !== '' ? '07' : this.dateType
          }
          const data = await this.sa_SpringJonLogView_pageList(parmas);
          this.tableData = data.data;
          this.totalCount = data.recordsTotal;
          this.tableLoading = false;
        } catch (error) {
          this.tableLoading = false;
        }
      },
      // 关闭
      async sa_SpringJonLogView_logKills() {
        try {
          const data = await this.sa_SpringJonLogView_logKill({
            logId: this.id
          });
          if (data) {
            this.$Message.success('关闭成功~~');
          }
        } catch (error) {
          console.log(error);
        }
      },
      // 查看详情
      async sa_SpringJonLogView_logDetails() {
        try {
          const data = await this.sa_SpringJonLogView_logDetail({
            logId: this.id
          });
          this.nextStatus = true;
          this.cronList = data;
        } catch (error) {
          console.log(error);
        }
      }
    },
    mounted() {
      this.Columns = Columns;
      // 获取元素高度
      this.getElementHeight();
      // 获取下拉列表
      this.sa_SpringJobInfoView_indexs();
      // 获取列表数据
      this.sa_SpringJonLogView_pageLists();
    }
  }
</script>
<style lang="less" scoped>
  #schedulingLog {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      .title {
        font-size: 14px;
        color: #fff;
        margin: 0px 10px 0px 10px;
      }
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>